import { useCallback } from 'react'

import { useCurrencySign } from 'app/common/components-next/currency'
import { ReportSection, Stub, ReportDetailsRoot } from 'app/common/templates-next/report-template'
import { ReportStatusIndicator } from 'app/components/common/reports/v3/ReportStatusIndicator'
import { Loading } from 'app/common/templates-next/page-template'
import { useReportResult } from 'app/dataProviders/reports/hooks'
import { ReportType } from 'app/dataTypes/reports'
import { useLazyLoading } from 'app/components/common/reports/v3/hooks/useLazyLoading'
import { ReportFinancesDataReplenishmentSummary } from 'app/dataTypes/reports/data/common/financesSummaryReplenishment'

import { HeaderBar } from './HeaderBar'
import { Summary } from './Summary'
import { BySchoolOrClassesTable } from './bySchoolOrClasses/BySchoolOrClassesTable'
import { ByStudentsTable } from './byStudents/ByStudentsTable'

const dataReplacement = (
  data: ReportFinancesDataReplenishmentSummary | null,
  visiblePortion: number,
): ReportFinancesDataReplenishmentSummary | null => {
  if (!data) return null
  const { type } = data
  return type === 'common'
    ? {
        ...data,
        items: data.items.slice(0, visiblePortion),
      }
    : {
        ...data,
        items: data.items.slice(0, visiblePortion),
      }
}

type Props = {
  reportId: null | string
  onReportId: (reportId: string | null) => void
}

export const Result = ({ reportId, onReportId }: Props) => {
  const currency = useCurrencySign()

  const resetReport = useCallback(() => {
    onReportId(null)
  }, [onReportId])

  const {
    data: fullData,
    loading: pending,
    requestResult,
  } = useReportResult(reportId, ReportType.FinancesSummaryReplenishment)

  const data = useLazyLoading({
    data: fullData,
    dataReplacement,
    skip: fullData?.type === 'common',
  })

  const header = !reportId ? '' : 'Отчет «Финансы: пополнения»'

  return (
    <ReportSection
      header={header}
      headerBar={<HeaderBar reportID={reportId} reportReady={!!data && !pending} />}
      fullscreenEnabled={!!data && !pending}
      skipPadding
    >
      {reportId && (
        <ReportStatusIndicator reportID={reportId} onFail={resetReport} onSuccess={requestResult} />
      )}

      {!data && !reportId && <Stub />}

      {reportId && pending && <Loading />}

      {data && <Summary title="ИТОГО" total={data.total} currency={currency} pending={pending} />}

      {data && (
        <ReportDetailsRoot header="Детализация отчета «Финансы: пополнения»">
          {data.type === 'common' && <BySchoolOrClassesTable data={data} currency={currency} />}
          {data.type === 'students' && <ByStudentsTable data={data} currency={currency} />}
        </ReportDetailsRoot>
      )}
    </ReportSection>
  )
}
